import React , { useState } from "react";

export default function ActivitesForm({ formData, handleChange }) {

const [membreDuGroupe, setMembreDuGroupe] = useState([]);

  const addMembreDuGroupe = () => {
    const newMembre = [...membreDuGroupe, ""];
    setMembreDuGroupe(newMembre);
    handleChange("membreDuGroupe",newMembre);
  };


  const handleMembreDuGroupeChange = (index, value) => {
    const newMembre = [...membreDuGroupe];
    newMembre[index] = value;
    setMembreDuGroupe(newMembre);
    handleChange("membreDuGroupe",newMembre);
  };

  return (
    <div className="subform" translate="no">
      <h2 className="text-center font-bold text-l border-2 border-blue-500 rounded-md p-4 mb-6">Activités</h2>
      <label>Titre de l'activité : </label>
      <input type="text" className="form-control" name="titreActivite" value={formData.titreActivite} onChange={handleChange}/>
      <label>Description de l'activité : </label>
      <input type="text" className="form-control" placeholder="(ex : Formation, accompagnement, cadrage...) " name="descActivite" value={formData.descActivite} onChange={handleChange}/>
      <label>Date de début : </label>
      <input type="date" className="form-control" name="dateDebutActivite" value={formData.dateDebutActivite} onChange={handleChange}/>
      <label>Date de fin : </label>
      <input type="date" className="form-control" name="dateFinActivite" value={formData.dateFinActivite} onChange={handleChange}/>
      <label>Durée de l'activité (en jours) : </label>
      <input type="text" className="form-control" name="dureeActivite" value={formData.dureeActivite} onChange={handleChange}/>
      <label>Nom du partenaire(s)/client(s) : </label>
      <input type="text" className="form-control" placeholder="(ex : ofi, scoops-ah, particulier...) " name="partenaireActivite" value={formData.partenaireActivite} onChange={handleChange}/>
      <label> Bénéficiaire(s) de l'activité : </label>
      <input type="text" className="form-control" placeholder="(ex : cooperative, groupement de producteurs...) " name="beneficiaireActivite" value={formData.beneficiaireActivite} onChange={handleChange}/>
      <label>Nombre total de bénéficiaire(s): </label>
      <input type="text" className="form-control" name="nombreBeneficiaireActivite" value={formData.nombreBeneficiaireActivite} onChange={handleChange}/>
      
      <label>Nombre total des hommes Bénéficiaire(s) : </label>
      <input type="text" className="form-control" name="beneficiaireHommeActivite" value={formData.beneficiaireHommeActivite} onChange={handleChange}/>
      <label>Nombre total des femmes Bénéficiaire(s) : </label>
      <input type="text" className="form-control" name="beneficiaireFemmeActivite" value={formData.beneficiaireFemmeActivite} onChange={handleChange}/>
      
      <label>Région : </label>
      <input type="text" className="form-control" name="regionActivite" value={formData.regionActivite} onChange={handleChange}/>
      <label>Ville : </label>
      <input type="text" className="form-control" name="villeActivite" value={formData.villeActivite} onChange={handleChange}/>
      
      <label>Activité(s) effectuée(s) en equipe ? : </label>
      <input type="radio" name="activiteEnEquipe" value="ouiEnEquipe" checked={formData.activiteEnEquipe === "ouiEnEquipe"} onChange={(e) => handleChange("activiteEnEquipe", e.target.value)}/>  Oui<br/>
      <input type="radio" name="activiteEnEquipe" value="nonEnEquipe" checked={formData.activiteEnEquipe === "nonEnEquipe"} onChange={(e) => handleChange("activiteEnEquipe", e.target.value)}/>  Non<br />

      {formData.activiteEnEquipe === "ouiEnEquipe" && (
        <div className="mt-3">
            <button type="button" className="btn btn-secondary mb-2" onClick={addMembreDuGroupe}>
              Ajouter le(s) participant(s)
            </button>

            {membreDuGroupe.map((p, index) => (
              <input
                key={index}
                type="text"
                className="form-control mb-2"
                placeholder={`Nom du participant ${index + 1}`}
                value={p}
                onChange={(e) => handleMembreDuGroupeChange(index, e.target.value)}
              />
            ))}
        </div>
      )}

      <label>L'activité est-elle liée a un projet ?</label>
      <input type="radio" name="radioLiaisonProjet" value="ouiLiaisonProjet" onChange={handleChange}/>  Oui<br/>
      <input type="radio" name="radioLiaisonProjet" value="nonLiaisonProjet" onChange={handleChange}/>  Non<br />

      {formData.radioLiaisonProjet === "ouiLiaisonProjet" && (
        <div className="mt-3">
          <label>Nom du Projet : </label>
          <input type="text" className="form-control" name="nomProjet" value={formData.nomProjet} onChange={handleChange}/>
      
        </div>
      )}
      <label>Observation particulières</label>
      <textarea className="form-control mb-2" rows="5" cols="40" placeholder="(ex : mentionnez les remarques, difficultés, incidences... rencontrés)" name="observationActivite" value={formData.observationActivite} onChange={handleChange}/>
       
     </div>
  );
}
